import SignInActivity from './SignInActivity';

export default SignInActivity;
